<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  <div class="astral-content-width astral-stack-l">
    @if (form) {
      <form class="astral-section-surface" [formGroup]="form" (ngSubmit)="onSubmit()">
        <astral-layout-group [columns]="1" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
        </astral-layout-group>
      </form>
    }

    @if (dataContext) {
      <section class="astral-stack-m">
        <app-list-view
          [columnDefinition]="itemListColumns"
          [itemsSource]="itemsList"
          [contextMenuDefinition]="menuDefinition"
          [preferencesKey]="'common.executor-group-form.items'"
          (rowClick)="itemClicked($event)"
        ></app-list-view>
        <div class="astral-form-actions astral-form-actions--start">
          <astral-button
            variant="primary"
            size="small"
            icon="plus"
            labelKey="EXECUTORGROUP.ADD_USER"
            type="button"
            [disabled]="isAddUserDisabled"
            (click)="addUser()"
          ></astral-button>
        </div>
      </section>
    }
  </div>
</section>
